import api from '@/api';

const { $pricing, $academic } = api;
export const { $types } = $pricing;
export const { $subjects, $competitions, $departments} = $academic;